export default __webpack_public_path__ + "static/media/hillside.578322e8.png";